module.exports = __webpack_public_path__ + "img/android_logo.1d3f3ac1.png";